import { cn } from '@/utils/cn';

export const FIELD_LEADING_ICON =
  'pointer-events-none absolute left-s3 top-1/2 z-[1] -translate-y-1/2 text-ds-muted';

export const FIELD_TRAILING_ICON =
  'absolute inset-y-0 right-0 z-[1] flex items-center pr-s3 text-ds-muted';

export function fieldIconData(opts: { leading?: boolean; trailing?: boolean }) {
  return {
    ...(opts.leading ? { 'data-leading-icon': '' as const } : {}),
    ...(opts.trailing ? { 'data-trailing-icon': '' as const } : {}),
  };
}

export function fieldControlClass(opts?: {
  error?: boolean;
  className?: string;
}): string {
  return cn('ds-field', opts?.error && 'border-[1.5px] border-ds-red', opts?.className);
}

/** Shared control class for raw fields that cannot use Input/Select. */
export const FIELD_CONTROL = fieldControlClass();

export function describedByIds(opts: {
  id: string;
  error?: boolean;
  hint?: boolean;
  extra?: string;
}): string | undefined {
  const ids: string[] = [];
  if (opts.error) ids.push(`${opts.id}-error`);
  else if (opts.hint) ids.push(`${opts.id}-hint`);
  if (opts.extra) ids.push(opts.extra);
  return ids.length ? ids.join(' ') : undefined;
}
